/* eslint-disable */


/**
 * Create styles for `<EditProfilePage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<EditProfilePage />` styles
 */
const editProfilePageStyles = ({ theme }) => ({
  icon: {
    color: `darkgray`,
  },
  phonePadding: {
    marginBottom: `15px`,
    marginTop: `15px`,
  },
  selectStyle: {
    color: `rgba(0, 0, 0, 0.54)`,
    fontFamily: `Roboto, Helvetica, Arial, sans-serif`,
    fontSize: `1rem`,
    lineHeight: `1`,
    padding: `0`,
  },
  spaceBottom10: {
    paddingBottom: `10px`,
  },
  spaceBottom15: {
    paddingBottom: `15px`,
  },
  spaceLeft25: {
    paddingLeft: `25px`,
  },
  spaceTop15: {
    paddingTop: `15px`,
  },
  spaceTop20: {
    paddingTop: `20px`,
  },
  width100: {
    width: `100%`,
  },
});

export default editProfilePageStyles;
